// Shrink font size so text fits its box: width-wise (wrapping) and,
// when boxHeightPx is given, height-wise too (lines * lineHeight <= height).
export const fitFontSize = (text, baseSize, boxWidthPx, boxHeightPx) => {
  const base = parseFloat(baseSize) || 12;
  if (!text) return base;
  const width = parseFloat(boxWidthPx) || 180;
  const height = parseFloat(boxHeightPx) || 0;
  const LINE_H = 1.15;
  const linesAt = (size) => {
    const perLine = Math.max(1, Math.floor(width / (size * 0.62)));
    return Math.ceil(String(text).length / perLine);
  };
  const fits = (size) => {
    const lines = linesAt(size);
    if (height > 0) return lines * size * LINE_H <= height + 1;
    return lines <= 2;
  };
  let size = base;
  while (size > 6 && !fits(size)) size -= 0.5;
  return size;
};

export default fitFontSize;
